import { render } from "./BusinessAccounts.vue?vue&type=template&id=1f4d21dc"
import script from "./BusinessAccounts.vue?vue&type=script&lang=js"
export * from "./BusinessAccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__